export class BranchCounter {
  public overtimeHours: number;
  public totalHours: number;

  public constructor() {
    this.overtimeHours = 0;
    this.totalHours = 0;
  }
}
